var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0H11H7V1L10.2994 1L6.00001 5.2994L6.70061 6L11 1.70061V5H12V1V0ZM0 1.5H7V2.5H1V11H9.5V5.5H10.5V11V12H0V11V2.5V1.5Z",
    fill: "#F7A246"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLink);
export default __webpack_public_path__ + "static/media/OpenLink.8b32566d8a4f835d1ab11fa6d0152671.svg";
export { ForwardRef as ReactComponent };